import React from 'react';
import './index.scss';
import {toJS} from 'mobx';

import {api} from '../../../../functions/api'

import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'

import CircularProgress from '@material-ui/core/CircularProgress';

import CustomTable from '../../../../components/complex/customTable'
import Search from '../../../../components/basic/search';
import CustomButton from '../../../../components/basic/CustomButton'
import CreateNewClient from './add'
import CustomSnackbar from '../../../../components/global/snackbar'
import DeleteDialog from '../../../../components/global/deleteDialog'

import queryString from 'query-string'

import { inject, observer } from 'mobx-react';

const TIMEOUT = 3000;

@inject('translate')
@inject('internal')
@observer
export default class ClientUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            openAddClientDlialog: false,
            searchTerm: ""
        }
    }

    componentDidMount() {
        this.loadClientMembers();
        //this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        this.props.internal.setRoute( this.props.routerData.history, this.props.routerData.location.pathname)

        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)

        let searchTerm;
        if(queries.searchterm) {
            searchTerm = queries.searchterm;
            this.setState({searchTerm: searchTerm})
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    setPermissions() {
        let permissions = toJS(this.props.internal.user.data.permissions.clients_members)
        this.dropDownMenuItems = []
        if(permissions.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                    action: "edit"
                }
            )
        }

        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.MODULES.CLIENTS.MENU_ITEMS.DELETE,
                    action: "delete"
                }
            )
        }

        if([1,2,5].indexOf(toJS(this.props.internal.user.data.role.id) > -1)) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.MODULES.CLIENTS.MENU_ITEMS.LOGIN_AS_MEMBER,
                    action: "login-as"
                }
            )
        }
    }

    dropDownMenuItems = [
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
        //     // url: "edit/tab=0"
        //     //url: "detail/tab=0"
        //     action: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.MODULES.CLIENTS.MENU_ITEMS.DELETE,
        //     //url: "delete",
        //     action: "delete"
        // }
    ]

    tableHeader = [
        {
            "title":"username",
            "numeric":false,
            sortBy: "last_name",
            "min_width": "130px"
        },
        {
            "title":"phone",
            "numeric":false,
            sortBy: "phone"
        },
        {
            "title":"email",
            "numeric":false,
            "min_width": "50px"
        },
        {
            "title":"role_id",
            "numeric":false
        }
    ];
    tableBody = ["username", "phone", "email", "role_id"]



    loadClientMembers = async (size = 10, page = 0, searchterm = "", by = "last_name", dir = "asc") => {

        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {

            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let idClient = toJS(this.props.routerData.match.params.idClient)
        let load_data = await api({
            method:'get',
            url:'clients/'+idClient+"/members",
            authorization: this.props.internal.user.access_token,
            params:{
                searchterm: searchterm,
                page:{
                    number:page,
                    size:size,
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    }
                ]

            }
        })

        if(load_data.success === true) {
            if(load_data.data) {
                for(let i=0; i< load_data.data.data.length; i++) {
                    if(load_data.data.data[i].data) {
                        let phone = load_data.data.data[i].data.phone
                        load_data.data.data[i].phone = phone

                        // let role_name = load_data.data.data[i].role.name
                        // load_data.data.data[i].role_name = role_name
                    }

                }
                this.props.internal.setDataForTable(load_data.data)

                this.setPermissions();
            }
        }
        else {
            //this.setState({openSnackbar: true, message: load_data.data.message})
            this.turnOffSnackBar();
        }
        this.setState({loading: false})
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.routerData.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadClientMembers()
    }

    handleClickOpenAddClientDlialog = () => {
        this.setState({openAddClientDlialog: !this.state.openAddClientDlialog})
    }
    handleCloseAddClientDlialog = () => {
        this.setState({openAddClientDlialog: !this.state.openAddClientDlialog})
    }

    handleCloseEditClientDlialog = () => {
        let actionEditData = {
            edit: false,
            id: null
        }
        this.props.internal.setActionEdit(actionEditData)
    }

    handleDeleteUser = () => {
        this.props.internal.setActionDelete();
        this.deleteUser(this.props.internal.actionDeleteObj.id)
    }

    deleteUser = async (idUser) => {
        let idClient = toJS(this.props.routerData.match.params.idClient)
        let delete_data = await api({
            method:'delete',
            url:'clients/'+idClient+"/members/"+idUser,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.setState({message: delete_data.data.message, openSnackbar: true})
            this.loadClientMembers();
        }
        else {
            this.setState({message: delete_data.data.message, openSnackbar: true})
            this.loadClientMembers();
        }
        this.turnOffSnackBar();
    }

    showSnackbar = (message, open, actionForDialog) => {
        if(actionForDialog) {
            this.setState({ openAddClientDlialog: false})
        }
        this.setState({message: message, openSnackbar: open})
        this.turnOffSnackBar();
        this.loadClientMembers();
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({message: "", openSnackbar: false})
        }, TIMEOUT)
    }

    render() {
        let permissions;
        if(!this.state.loading) {
            permissions = toJS(this.props.internal.user.data.permissions.clients_members);
        }

        return (
            <div className={'client-users-container'}>
                <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                <CreateNewClient
                    open={this.state.openAddClientDlialog}
                    onClose={this.handleCloseAddClientDlialog}
                    title={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_USER_DIALOG_TITLE}
                    routerData={this.props.routerData}
                    showSnackbar={this.showSnackbar}
                />
                {/* dialog okno pre edit */}
                {this.props.internal.actionEdit.edit ?
                <CreateNewClient
                    open={this.props.internal.actionEdit.edit}
                    onClose={this.handleCloseEditClientDlialog}
                    title={this.props.translate.i18n.MODULES.CLIENTS.EDIT_CLIENT_TITLE}
                    routerData={this.props.routerData}
                    showSnackbar={this.showSnackbar}
                    idUser={this.props.internal.actionEdit.id}
                />
                :
                null
                }
                <DeleteDialog
                    open={this.props.internal.actionDelete}
                    title={this.props.translate.i18n.MODULES.CLIENTS.DELETE_USER_TITLE}
                    content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                    btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                    delete={this.handleDeleteUser}
                />
                <div className={'flex space-between'}>
                    <Search placeholder={this.props.translate.i18n.MODULES.CLIENTS.SEARCH_USER} classes={'client-search'} onChange={this.handleSearch} value={this.state.searchTerm }/>
                    {!this.state.loading && permissions.store ?
                        <CustomButton
                        mystyle={'btn-orange-bg border-radius-18'}
                            title={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_USER}
                            onClick={this.handleClickOpenAddClientDlialog}
                        >
                            <Icon path={mdiPlus} size={1}  />
                        </CustomButton>
                        :
                        null
                    }

                </div>
                {this.state.loading ?
                    <CircularProgress className={'circular-progress'} />
                    :
                    //null
                   <CustomTable
                        dropDownMenuItems={this.dropDownMenuItems}
                        module={'/clients'}
                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                        handleChangePage={this.handleChangePage}
                        handleSort={this.handleSort}
                        header={this.tableHeader}
                        body={this.tableBody}
                    />
                   }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/users/index.js